/**
 * Spacing design tokens from Figma (Queen One Design System).
 * Source: Spacing variable collection.
 * MUI spacing scale: theme.spacing(n) aligns with key n (e.g. theme.spacing(3) = 8px = spacing[3]).
 */

export const spacing = {
  1: 0,
  2: 4,
  3: 8,
  4: 12,
  5: 16,
  6: 20,
  7: 24,
  8: 40,
  9: 48,
  10: 56,
  11: 64,
  12: 80,
  13: 88,
  14: 104,
  15: 120,
} as const;
